export default __webpack_public_path__ + "static/media/TotalUploads.7e8bcc20.svg";